import type { FaireProductEntity } from "../../entity_types/product";

export const p_f58q66u0wy: FaireProductEntity = {
  token: "p_f58q66u0wy",
  type: "product",
  name: "Panda Hug Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/bd938d6770f482d6aca7d750da67a4d48d052d8d47298aa0f968ca49300d85ef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/35ad0f3264b30dee5ca5ec0ac6d0a73c1db71568126b42fd991d8f4a90e79a2f.jpeg",
    "https://cdn.faire.com/fastly/6a2fd3c2aa7590406dbc086e396d465dcf4ad3affe5f17f7c82d42694f5d4bdf.jpeg",
    "https://cdn.faire.com/fastly/f42a4768a9fd6621178b76fe79321a38b5f46785b6bf0c042601dbcb98fef6af.jpeg",
    "https://cdn.faire.com/fastly/d97fd5e5171e2014acbe5704ff4090ffce95429f79ce2d2062077597235df42e.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:35.378Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
